import { useEffect } from "react"
import { useNavigation } from "@react-navigation/native"

export const useNewSubscriberScreenRedirection = ({
    fastTrackData,
    emailB64,
    redirectIfCreatedByAdmin = false,
}) => {
    const navigation = useNavigation()

    const subscriptionMetadata = fastTrackData?.subscriptionMetadata
    const subscriptionStatus = fastTrackData?.subscriptionStatus
    const possibleSlots = fastTrackData?.user?.slots_possible

    const hasActiveSubscription = ["paid", "empty"].includes(subscriptionStatus)
    const goToAdminSubscription =
        redirectIfCreatedByAdmin && subscriptionMetadata?.is_created_by_admin
    // A "stage préalable" defers the recurring subscription start: the parent's
    // first experience is the stage itself, so we skip the slot-selection flow
    // and confirm the stage instead.
    const hasStagePreable = subscriptionMetadata?.holiday_courses?.length > 0

    const willRedirect = Boolean(
        fastTrackData && (hasActiveSubscription || goToAdminSubscription)
    )

    useEffect(() => {
        if (hasActiveSubscription) {
            if (hasStagePreable) {
                return navigation.navigate("stage-payment-success", {
                    user: emailB64,
                })
            }
            if (!possibleSlots) {
                return navigation.navigate("subscribe/possible-slots", {
                    user: emailB64,
                })
            }
            return navigation.navigate("subscribe", { user: emailB64 })
        }
        if (goToAdminSubscription) {
            navigation.navigate("invoice-payment", { user: emailB64 })
        }
    }, [hasActiveSubscription, goToAdminSubscription, hasStagePreable])

    return { willRedirect }
}
